module.exports = __webpack_public_path__ + "media/images/application/template/logos/reviews-logo-0d12a6124dab0e314db806d8e3a743b9.png";